import React from 'react';
import { Select, SelectItem } from 'ui/Input';
import { IFXCurrency } from './FxRates.model';


const renderFromField = (currency: IFXCurrency[]) => (
  <Select name="from" label="From" disabled>
    {currency.map(({ value, title }) => (
      <SelectItem value={value} key={value}>
        {title}
      </SelectItem>
    ))}
  </Select>
);

const renderToField = (currency: IFXCurrency[]) => (
  <Select name="to" label="To">
    {currency.map(({ value, title }) => {
      if (value !== 'ghsRates') {
        return (
          <SelectItem value={value} key={value}>
            {title}
          </SelectItem>
        );
      }
      return null;
    })}
  </Select>
);

const fxRatesFields = (currency: IFXCurrency[]) => (
  <>
    {renderFromField(currency)}
    {renderToField(currency)}
  </>
);

export default fxRatesFields;
